module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-preview (copy)-60ff66d594651735ccf0fcebb3c6e45a.png";